export const SEGMENTED_FRAME_REPORT_ID = '40';
export const ATOMIC_FRAME_REPORT_ID = '3F';
export const REPORT_ID_63 = 63;
export const REPORT_ID_64 = 64;
export const NETWORK_LAYER_SIZE = 62;
export const SEGMENTED_FRAME_NETWORK_LAYER_SIZE = 61;
export const NON_EXTENDED_FRAME_SIZE = 32;
export const EXTENDED_FRAME_SIZE = 64;
export const DEFAULT_REPORT_COUNT = 31;

export const READ_HOLDER_SERIAL_NUMBER_TIMEOUT_MS_USB = 500;
export const READ_HOLDER_SERIAL_NUMBER_TIMEOUT_MS_BLE = 1000;
export const READ_HOLDER_SERIAL_NUMBER_TIMEOUT_MS_BLE_ON_SYSTEM_STATUS_CHANGED = 5000;

export const BLE_EXTENDED_FRAME_HEADERS = ['C', 'D'];
export const BLE_ATOMIC_FRAME_HEADER = '00';

export const SCP_BYTES = {
    NETWORK_LAYER_FRAME_SIZE: {
        offset: 1,
        size: 1,
    },
    EXTENDED_FRAME_SEGMENT_ID: {
        offset: 2,
        size: 1,
    },
    FRAME_NETWORK_LAYER: {
        offset: 2,
    },
    EXTENDED_ATOMIC_FRAME_NETWORK_LAYER: {
        offset: 2,
    },
    EXTENDED_SEGMENTED_FRAME_NETWORK_LAYER: {
        offset: 3,
    },
};
